"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVE_TXID_VERSIONS = exports.ACTIVE_UTXO_MERKLETREE_TXID_VERSIONS = exports.TXIDVersion = exports.BlindedCommitmentType = exports.TXOPOIListStatus = void 0;
var TXOPOIListStatus;
(function (TXOPOIListStatus) {
    TXOPOIListStatus["Valid"] = "Valid";
    TXOPOIListStatus["ShieldBlocked"] = "ShieldBlocked";
    TXOPOIListStatus["ProofSubmitted"] = "ProofSubmitted";
    TXOPOIListStatus["Missing"] = "Missing";
})(TXOPOIListStatus || (exports.TXOPOIListStatus = TXOPOIListStatus = {}));
var BlindedCommitmentType;
(function (BlindedCommitmentType) {
    BlindedCommitmentType["Shield"] = "Shield";
    BlindedCommitmentType["Transact"] = "Transact";
    BlindedCommitmentType["Unshield"] = "Unshield";
})(BlindedCommitmentType || (exports.BlindedCommitmentType = BlindedCommitmentType = {}));
var TXIDVersion;
(function (TXIDVersion) {
    TXIDVersion["V2_PoseidonMerkle"] = "V2_PoseidonMerkle";
    TXIDVersion["V3_PoseidonMerkle"] = "V3_PoseidonMerkle";
    // V3_KZG = 'V3_KZG',
})(TXIDVersion || (exports.TXIDVersion = TXIDVersion = {}));
exports.ACTIVE_UTXO_MERKLETREE_TXID_VERSIONS = [
    TXIDVersion.V2_PoseidonMerkle,
    TXIDVersion.V3_PoseidonMerkle,
];
exports.ACTIVE_TXID_VERSIONS = [
    TXIDVersion.V2_PoseidonMerkle,
    TXIDVersion.V3_PoseidonMerkle,
];
